import React from 'react';
import styles from './ValorInput.module.css';

interface ValorInputProps {
  label?: string;
  value: number;
  onChange: (value: number) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  required?: boolean;
}

// Função para formatar valor como moeda brasileira
const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value).replace('R$', '').trim();
};

// Função para converter string formatada em número
const parseCurrency = (formattedValue: string): number => {
  const cleanValue = formattedValue
    .replace(/[^\d,.]/g, '')
    .replace(/\./g, '')
    .replace(',', '.');
  
  const parsed = parseFloat(cleanValue);
  return isNaN(parsed) ? 0 : parsed;
};

export const ValorInput: React.FC<ValorInputProps> = ({
  label,
  value,
  onChange,
  placeholder = '0,00',
  disabled = false,
  error,
  required = false,
}) => {
  const [displayValue, setDisplayValue] = React.useState(formatCurrency(value));

  React.useEffect(() => {
    setDisplayValue(formatCurrency(value));
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const cleanInput = inputValue.replace(/[^\d,.\s]/g, '');
    const numericValue = parseCurrency(cleanInput);
    const formatted = formatCurrency(numericValue);
    setDisplayValue(formatted);
    onChange(numericValue);
  };

  const handleBlur = () => {
    setDisplayValue(formatCurrency(value));
  };

  return (
    <div className={styles.inputContainer}>
      {label && (
        <label className={styles.label}>
          {label}
          {required && <span style={{ color: 'var(--color-error-500)' }}> *</span>}
        </label>
      )}
      <div className={styles.inputWrapper}>
        <span className={styles.currencySymbol}>R$</span>
        <input
          type="text"
          className={`${styles.input} ${error ? styles['input--error'] : ''}`}
          value={displayValue}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          disabled={disabled}
          inputMode="decimal"
        />
      </div>
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
};
